import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';

import api from './../../service/api';

const Param = () => {
    var paramEmpty = {
        driverCommission: null,
        truckWear: null
    }

    const [params, setParams] = useState(paramEmpty);
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);

    const onInputChange = (e, name) => {
        const val = (e.value) || '';
        let _params = { ...params };
        _params[`${name}`] = val;
        setParams(_params);
    }

    const listParams = () => {
        api().get('/param/list').then(response => {
            if(response.status === 200 && response.data.result){
                var _params = {...params};
                ['driverCommission', 'truckWear'].forEach(paramName => {
                    var found = response.data.data.find(param => param.name === paramName);
                    if(found) _params[paramName] = (found.valuefor);
                });
                setParams(_params);
            }
        });
    }

    const handleParams = () => {
        setDisabled(true);
        setLoading(true);


        Object.keys(params).forEach(paramName => {
            return api().post('/param/update', { name: paramName, value: params[paramName] }).then(response => {
                setDisabled(false);
                setLoading(false);
                if(response.status === 200 && response.data.result) {
                    toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            });
        });
      
    }

    useEffect(() => {
        listParams();
    }, []);

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <div className="p-fluid">
                        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5 className="mb-4">Parâmetros</h5>
                        </div>
                        <div className="formgrid grid">
                            <div className="field lg:col-6 col-12">
                                <label htmlFor="truckWear">Porcentagem de Depreciação (%)</label>
                                <InputNumber value={params['truckWear']} disabled={disabled} id="truckWear" currency='BRL' maxFractionDigits={2}  mode='decimal' onValueChange={(e) => onInputChange(e, 'truckWear')}  />
                            </div>
                            <div className="field lg:col-6 col-12">
                                <label htmlFor="driverCommission">Comissão do Motorista (%)</label>
                                <InputNumber value={params['driverCommission']} disabled={disabled} id="driverCommission" currency='BRL' maxFractionDigits={2}  mode='decimal' onValueChange={(e) => onInputChange(e, 'driverCommission')}  />
                            </div>
                        </div>
                        <div className='formgrid'>
                            <div className='field col-2'>
                                <Button label='Salvar' onClick={handleParams} loading={loading} className='p-button-info' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Param;